// extracted by mini-css-extract-plugin
export default {"uriSingleRow":"redirect-uri-row__uriSingleRow___oE-No","uriRow":"redirect-uri-row__uriRow___Iu2nW","deleteUriButton":"redirect-uri-row__deleteUriButton___sNe+y"};